import { c as _c } from "react/compiler-runtime";
import { useMutation } from "@tanstack/react-query";
import * as z from "zod";
export const forgotPasswordSchema = z.object({
  username: z.string().email("Please enter a valid email address")
});
export function useForgotPassword() {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = {
      mutationFn: _temp
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const forgotPasswordMutation = useMutation(t0);
  return forgotPasswordMutation;
}
async function _temp(data) {
  const response = await fetch(`${process.env.NEXT_PUBLIC_API_URL}/auth/forgot-password`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json"
    },
    body: JSON.stringify({
      username: data.username
    })
  });
  if (!response.ok) {
    const error = await response.json();
    throw new Error((error as {
      message: string;
    }).message);
  }
  const responseData = await response.json();
  return responseData;
}